import React from "react";

export const Box = (props) => {
  const classes = ` bg-white rounded border ${props.className}`;
  const styles = props.style ?? {};

  return (
    <div className={classes} style={styles}>
      {props.children}
    </div>
  );
};
